export default __webpack_public_path__ + "static/pf1-5d898eb562de66db06229fca8f40c79b.jpg";